
export default function NewsHeroSection() {
  return (
    <section 
      className="relative py-24 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/4298e46bd1d75a59e74d9270cf32d340.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            News & Updates
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-4xl mx-auto leading-relaxed">
            Stay informed with the latest developments in pharmacy, veterinary medicine, and healthcare policy across Canada
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-blue-400 mb-2">150+</div>
              <div className="text-sm md:text-base">News Articles Monthly</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-blue-400 mb-2">25</div>
              <div className="text-sm md:text-base">Policy Updates Weekly</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-blue-400 mb-2">48hrs</div>
              <div className="text-sm md:text-base">Breaking News Response</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-blue-400 mb-2">13</div>
              <div className="text-sm md:text-base">Provincial Correspondents</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
